<template>
  <div>
    <div class="mb-3 vx-row">
      <div id="customer_details" class="w-full vx-col">
        <vx-card>
          <div class="w-full con-expand-users">
              <div class="flex items-center justify-between con-btns-user">
                <div class="flex items-center justify-start con-userx">
                  <vs-avatar color="primary" :text="supplierDetails.company_name"/>
                  <span class="font-semibold text-primary">{{ supplierDetails.company_name }}</span>
                   <vs-chip size="small" class="ml-2" transparent color="#7952B3">
                      {{ supplierDetails.account_currency }}
                    </vs-chip>
                </div>
                <div class="flex">

                </div>
              </div>
          </div>
        </vx-card>
      </div>
    </div>
    <vs-tabs :value="active_step" :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none"
             id="profile-tabs" :key="isSmallerScreen">

      <!-- GENERAL -->
      <vs-tab icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'General Details' : ''">
        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
          <other-supplier-profile v-on:fetchSupplierData="fetchSupplierData($event)"/>
        </div>
      </vs-tab>
      <vs-tab v-if="$canAny(['view-other-suppliers', 'create-edit-other-suppliers'])" icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? 'Users' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <SupplierUsersList/>           
        </div>
      </vs-tab>
      <vs-tab
        v-if="$canAny(['view-other-suppliers', 'create-edit-other-suppliers'])"
        icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Services' : ''">
        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
          <other-supplier-services/>
        </div>
      </vs-tab>
      <vs-tab
        v-if="$canAny(['view-other-suppliers', 'create-edit-other-suppliers'])"
        icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Purchase History' : ''">
        <div class="mt-4 ml-0 tab-general md:ml-4 md:mt-0">
          <other-supplier-orders-list/>
        </div>
      </vs-tab>
      <!-- <vs-tab
        v-if="$canAny(['view-other-suppliers', 'create-edit-other-suppliers'])"
        icon-pack="feather" icon="icon-box" :label="!isSmallerScreen ? 'Service categories' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <other-supplier-category-manage/>
        </div>
      </vs-tab> -->

    </vs-tabs>
  </div>
</template>

<script>
import OtherSupplierProfile
  from "@/views/pages/supplier-manage/other-suppliers/sundry-supplier-tabs/OtherSupplierProfile";
import OtherSupplierServices
  from "@/views/pages/supplier-manage/other-suppliers/sundry-supplier-tabs/OtherSupplierServices";
import OtherSupplierOrdersList
  from "@/views/pages/supplier-manage/other-suppliers/sundry-supplier-tabs/service-orders/OtherSupplierOrdersList";
import OtherSupplierCategoryManage
  from "@/views/pages/supplier-manage/other-supplier-category/OtherSupplierCategoryManage";
import SupplierUsersList from "./SupplierUsersList.vue";

export default {
  components: {
    OtherSupplierProfile,
    OtherSupplierServices,
    OtherSupplierOrdersList,
    OtherSupplierCategoryManage,
    SupplierUsersList,
  },
  data() {
    return {
      active_step: this.$route.query.step ? this.$route.query.step : '0',
      supplierDetails: {}
    }
  },
  methods: {
    fetchSupplierData(data) {
      this.supplierDetails = data
    }
  },
  mounted() {
    // this.active_step = this.$route.query.step
  },
  computed: {
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
